import React from 'react'
import { ModalComponent, TextFieldIcon, TextAreaIcon,  } from '../../_components'
import { Formik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import { setDisplayModal, setSavePurchase, setSavePurchaseSeeds, setSaveLabor, 
    setHarvestTools, setSaveLabor2, setSaveRevenue
} from '../../_slices/AppSlice'

export default function FormEntry( {} ) {
    const dispatch = useDispatch()
    const state = useSelector( state => {
        return {
          title: state.application.displayModal?.title,
          flag: state.application.displayModal?.flag,
          purchaseTools: state.application.purchaseTools,
          seeds: state.application.purchaseSeeds,
          tag: state.application.displayModal?.tag,
          labor: state.application.labor,
          labor2: state.application.labor2,
          harvestTools: state.application.harvestTools,
          revenue: state.application.revenue,
        }
    } )

    const handleOpen = () => dispatch( setDisplayModal( { flag: false, title: "" } ) )

    const handleSubmitForm = async ( values ) => {

        if( state.title?.toLowerCase() === "purchase of tools" ) {
            if( parseFloat( values?.qty ) > 0  && parseFloat( values.rate ) > 0 && values.item !== "" ) {
                await dispatch( setSavePurchase( [ ...state.purchaseTools, { 
                    item: values.item,
                    amount: parseFloat( values?.qty ) * parseFloat( values.rate ),
                    rate: values.rate,
                    qty: values.qty,
                    title: state.title?.toLowerCase()
                } ] ) )
            }
        }

        if( state.tag?.toLowerCase() === "seeds" ) {
            if( parseFloat( values?.qty ) > 0  && parseFloat( values.rate ) > 0 ) {
                await dispatch( setSavePurchaseSeeds( [ ...state.seeds, { 
                    item: values.item,
                    amount: parseFloat( values?.qty ) * parseFloat( values.rate ),
                    rate: values.rate,
                    qty: values.qty,
                    title: state.title,
                    tag: state.tag?.toLowerCase()
                } ] ) )
            }
        }

        if( state.tag?.toLowerCase() === "labor" ) {
            if( parseFloat( values?.qty ) > 0  && parseFloat( values.rate ) > 0 ) {
                await dispatch( setSaveLabor( [ ...state.labor, { 
                    item: values.item,
                    amount: parseFloat( values?.qty ) * parseFloat( values.rate ),
                    rate: values.rate,
                    qty: values.qty,
                    title: state.title,
                    tag: state.tag?.toLowerCase()
                } ] ) )
            }
        }

        if( state.tag?.toLowerCase() === "labor1" ) {
            if( parseFloat( values?.qty ) > 0  && parseFloat( values.rate ) > 0 ) {
                await dispatch( setSaveLabor2( [ ...state.labor2, { 
                    item: values.item,
                    amount: parseFloat( values?.qty ) * parseFloat( values.rate ),
                    rate: values.rate,
                    qty: values.qty,
                    title: state.title,
                    tag: state.tag?.toLowerCase()
                } ] ) )
            }
        }

        if( state.title?.toLowerCase() === "harvest tools") {
            if( parseFloat( values?.qty ) > 0  && parseFloat( values.rate ) > 0 ) {
                await dispatch( setHarvestTools( [ ...state.harvestTools, { 
                    item: values.item,
                    amount: parseFloat( values?.qty ) * parseFloat( values.rate ),
                    rate: values.rate,
                    qty: values.qty,
                    title: state.title
                } ] ) )
            }
        }

        if( state.tag?.toLowerCase() === "revenue") {
            if( parseFloat( values?.qty ) > 0  && parseFloat( values.rate ) > 0 ) {
                await dispatch( setSaveRevenue( [ ...state.revenue, { 
                    item: values.item,
                    category: values.category,
                    amount: parseFloat( values?.qty ) * parseFloat( values.rate ),
                    rate: values.rate,
                    qty: values.qty,
                    title: state.title
                } ] ) )
            }
        }

        // console.log(  state.tag?.toLowerCase() );

        //close modal
        await handleOpen()
    }

    // const handleDisplay = ( tag, title ) => {
        // state.tag?.toLowerCase() !== "seeds" || state.tag?.toLowerCase() !== "labor" || state.tag?.toLowerCase() === "labor1" || state.title?.toLowerCase() !== "seeds" 
    //     switch( tag?.toLowerCase() ) {
    //         case "seeds":
    //             return true
    //     }
    // }

    // console.log( "tag",state.tag?.toLowerCase()  );
    // console.log( "title", state.title );

    const { tag, title } = state 

    return (
      <ModalComponent title={state.title} open={state.flag} handleOpen={handleOpen}>
        <Formik
            initialValues={{
                category: "",
                item: "",
                qty: "",
                rate: "",
                amount: "",
            }}>
            { ( { handleChange, values, errors } ) => {
                return (
                  <form>
                    {/* {( state.title?.toLowerCase() === "purchase of tools" || state.title?.toLowerCase() === "purchase of seeds" || state.tag?.toLowerCase() === "seeds" ) && ( */}
                      <div className="grid md:grid-cols-2 lg:grid-cols-2 grid-cols-1 gap-3 my-3 mb-2">
                          {/* {console.log(state.tag?.toLowerCase())} */}
                            {tag?.toLowerCase() === "revenue" && (
                                <TextFieldIcon
                                type="text"
                                name="category"
                                value={values?.category}
                                handleChange={handleChange}
                                label="Category"
                                question="Category" 
                                required={ tag?.toLowerCase() === "revenue" && true} 
                                /> 
                            )}

                          { !( tag?.toLowerCase() === "seeds" || tag?.toLowerCase() === "labor" || tag?.toLowerCase() === "purchase of seeds" || tag?.toLowerCase() === "labor1" || tag?.toLowerCase() === "revenue" ) && (
                            <TextFieldIcon
                                type="text"
                                name="item"
                                value={values?.item}
                                handleChange={handleChange}
                                label="Item"
                                question="Item(Name of Item)" 
                                required={ state.tag?.toLowerCase() !== "seeds" ||  state.tag?.toLowerCase() !== "labor" && true} 
                            /> 
                            ) }

                          <TextFieldIcon
                              type="number"
                              name="qty"
                              value={values?.qty}
                              handleChange={handleChange}
                              label="Quantity"
                              question="Quantity" 
                              required={true} 
                          />

                          <TextFieldIcon
                            type="number"
                            name="rate"
                            value={values?.rate}
                            handleChange={handleChange}
                            label="Rate"
                            question="Rate(UGX)" 
                            required={true} 
                          />

                          <TextFieldIcon
                            type="number"
                            name="amount"
                            value={parseFloat( values?.rate ) * parseFloat( values?.qty)}
                            handleChange={handleChange}
                            label="Amount"
                            question="Amount(UGX" 
                            disabled={true}
                            required={false} 
                          />
                      </div>
                    {/* )} */}

                      <div className="self-end flex items-center my-2">
                          <button className="bg-blue-500 px-2 py-1 mx-2 text-sm text-white rounded-sm" type="button" onClick={handleOpen}>
                              {`Cancel`}
                          </button>
                          <button className="bg-green-700 px-3 py-1 mx-2 text-sm text-white rounded-sm" type="button" onClick={() => handleSubmitForm( values, errors )}>
                              {`Save`}
                          </button>
                      </div>
                  </form>
                )
            } }
        </Formik>
      </ModalComponent>
    )
}
